import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';

function PopBookCompany(props) {
  const {open, close} = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const listItems = ['자랑 총판', '서울 총판', '서울 총판', '자랑 총판', '자랑 총판', '자랑 총판', '자랑 총판'];
  const handleClick = (index) => {
    setSelectedItem(index);
  };
  return (
    <Modal open={open} close={close} type="com_input pop_book_company">
      <h2 className="pop_tit line">총판 관리</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="tit_field top">총판 목록</li>
          <li>
            <ul className="com_scroll_list pick">
              {listItems.map((item, index) => (
                <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => handleClick(index)}>
                  {item}
                </li>
              ))}
            </ul>
          </li>

          <hr className="com_divider type_inner" />
          <li className="tit_field">총판 정보</li>
          <li className="input_field">
            <input type="text" className="input lightGray" defaultValue={`총판명 입력`} />
            <button className="com_btn gray xs">총판 삭제</button>
          </li>
          <table className="com_board_list type_row">
            <colgroup>
              <col width="20%" />
              <col width="80%" />
            </colgroup>
            <tbody>
              <tr>
                <th>대표자</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={`김대표`} />
                  </div>
                </td>
              </tr>
              <tr>
                <th>대표 전화번호</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={`02-1234-1324`} />
                    <input type="text" className="input" defaultValue={`010-1234-1324`} />
                  </div>
                </td>
              </tr>
              <tr>
                <th>FAX 번호</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={`02-1234-1324`} />
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  1 담당자 이름 /<br />
                  전화번호
                </th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={`김당담 과장`} />
                    <input type="text" className="input" defaultValue={`010-1234-2314`} />
                    <button className="btn btn_add_gray" />
                  </div>
                </td>
              </tr>
              <tr>
                <th rowSpan="2">사업장 주소</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={``} />
                    <button className="com_btn gray s wl">우편번호</button>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="border_left">
                  <input type="text" className="input full" placeholder="상세 주소 입력" />
                </td>
              </tr>
              <tr>
                <th>사업자 등록증</th>
                <td>
                  <div className="com_input_upload">
                    <Upload title="파일 등록" className="com_btn gray s wl" />
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      <button type="button" className="btn_down" onClick={() => {}}></button>
                    </p>
                  </div>
                </td>
              </tr>
              <tr>
                <th>노출 여부</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <div className="check">
                      <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                      <label htmlFor="rdo_01">노출</label>
                      <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                      <label htmlFor="rdo_02">미노출</label>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <li className="tit_field">계약 조건</li>
          <table className="com_board_list type_row">
            <colgroup>
              <col width="28%" />
              <col width="60%" />
            </colgroup>
            <tbody>
              <tr>
                <th>대표자</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={`50%`} />
                  </div>
                </td>
              </tr>
              <tr>
                <th>대표자</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={`40%`} />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="btn_container">
            <button className="com_btn orange xs">등록</button>
          </div>
        </ul>
      </div>
    </Modal>
  );
}

export default PopBookCompany;
